import { removeLeadingSlash } from '@/utils/stringUtils.js'

export async function tryFn(fn) {
  try {
    await fn()
  } catch (err) {
    console.error(err)
  }
}

export function locale() {
  const availableLocales = ['en', 'ja']
  const currentLocale = window.location.pathname.split('/').filter(Boolean)[0]
  return availableLocales.includes(currentLocale) ? currentLocale : 'en'
}

export function safeInternalPath(path) {
  if (!path) {
    return ''
  }

  const trimmed = path.trim()
  let decoded = trimmed
  try {
    decoded = decodeURIComponent(trimmed)
  } catch {
    return ''
  }

  if (unsafeInternalPath(trimmed) || unsafeInternalPath(decoded)) {
    return ''
  }

  return trimmed
}

function unsafeInternalPath(value) {
  return !value.startsWith('/') || value.startsWith('//') || value.includes('://') || value.includes('\\')
}

export function toUrl(path) {
  if (!path) {
    return ''
  }

  const isFullUrl = /^(http|https):\/\//.test(path)
  if (isFullUrl) {
    return path
  }

  const availableLocales = ['en', 'ja']
  const localeInPath = availableLocales.includes(path.split('/').filter(Boolean)[0])
  if (localeInPath) {
    return path
  }

  const relPath = removeLeadingSlash(path)
  const useLocale = !relPath.startsWith('admin')
  return useLocale ? `/${locale()}/${relPath}` : `/${relPath}`
}

export function redirectTo(path, target = '_self') {
  return window.open(toUrl(path), target)
}

export function isUrl(url) {
  try {
    new URL(url)
  } catch {
    return false
  }

  return true
}

export function urlSearchParam(key, fallback = null) {
  const params = new URLSearchParams(window.location.search)
  return params.get(key) ?? fallback
}
